<template>
  <div>
    <v-form ref="form">
      <NewInsuranceForm :form="form" @submit="submit" :is-edit="isEdit" />
    </v-form>
    <InsuranceContacts
      title="CONTATOS RELACIONAMENTO"
      :list="form.contatos_relacionamento"
      @remove="removeRelationshipContact"
      @open="goToRelationshipContacts"
      @edit="editRelationshipContact"
      :error-messages="relationshipContactErrors"
    />
    <InsuranceContacts
      title="CONTATOS LINHA DE CRÉDITO"
      :list="listCreditLineContact"
      @remove="removeCreditLineContact"
      @open="goToCreditLineContact"
      @edit="editCreditLineContact"
      :error-messages="creditLineContactErrors"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            class="white--text pink"
            v-html="'CANCELAR'"
            width="100%"
            :to="{ name: 'insurance_company' }"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <BaseButton
            class="white--text secondary"
            v-html="'PRÓXIMO'"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <NewContactModal
      v-if="modalCredit"
      v-model="modalCredit"
      :item="creditLineContact"
      :title="titleModal"
      @close="closeModalCredit"
      @submit="addNewContact"
    />
  </div>
</template>
<script>
import NewInsuranceForm from "../components/NewInsuranceForm";
import InsuranceContacts from "../components/InsuranceContacts";
import NewContactModal from "@/components/NewContactModal.vue";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { SwitchText } from "@/mixins/SwitchMixin.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import * as BRUtils from "@brazilian-utils/brazilian-utils";
import _ from "lodash";
export default {
  data: () => ({
    modalCredit: false,
    creditLineContact: {},
    relationshipContactErrors: [],
    creditLineContactErrors: [],
    titleModal: null,
    listCreditLineContact: []
  }),
  components: {
    NewInsuranceForm,
    InsuranceContacts,
    NewContactModal
  },
  mixins: [InsuranceCompanyMixin, SwitchText, LoadingRequest],
  computed: {
    ...mapState("insuranceCompany", ["currentLegalPerson"]),
    contactsStep() {
      return {
        name: "insurance_company new contact",
        step: 1
      };
    },
    modalityStep() {
      return {
        name: "insurance_company step modality",
        step: 2
      };
    }
  },
  created() {
    this.updateListCreditLineContact();
  },
  methods: {
    ...mapActions("insuranceCompany", ["requestLegalPerson"]),
    ...mapActions(["showAlertNotification"]),
    fetchLegalPerson() {
      this.withLoading(
        this.requestLegalPerson(this.form.cnpj.replace(/[\D]+/g, ""))
      );
    },
    updateListCreditLineContact() {
      this.listCreditLineContact = _.cloneDeep(
        this.form.contatos_linha_credito
      );
    },
    removeRelationshipContact(item) {
      if (item.id && !item.pode_excluir) {
        this.showAlertNotification({
          message: `Não é possível excluir esse contato, por estar vinculado ao grupo econômico`,
          type: "error"
        });
      } else {
        const index = this.form.contatos_relacionamento.indexOf(item);
        this.form.contatos_relacionamento.splice(index, 1);
      }
    },
    removeCreditLineContact(item) {
      const index = this.form.contatos_linha_credito.indexOf(item);
      this.form.contatos_linha_credito.splice(index, 1);
      this.updateListCreditLineContact();
    },
    goToRelationshipContacts() {
      this.$emit(
        "relationshipContact",
        this.payloadInsuranceCompany(this.form, this.contactsStep, {
          ativo: true
        })
      );
    },
    goToCreditLineContact() {
      this.creditLineContact = {
        ativo: true,
        nome: null,
        email: null,
        telefone1: null,
        telefone2: null,
        departamento: null
      };
      this.titleModal = "INCLUIR NOVO CONTATO LINHA DE CRÉDITO";
      this.modalCredit = true;
    },
    closeModalCredit() {
      this.modalCredit = false;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(this.form, this.modalityStep)
      );
    },
    validate() {
      const hasRelationshipContact = this.form.contatos_relacionamento.length;
      const hasCreditLineContact = this.form.contatos_linha_credito.length;
      if (hasRelationshipContact < 1) {
        this.relationshipContactErrors = [
          "É preciso adicionar pelo menos um contato."
        ];
      } else {
        this.relationshipContactErrors = [];
      }
      if (hasCreditLineContact < 1) {
        this.creditLineContactErrors = [
          "É preciso adicionar pelo menos um contato."
        ];
      } else {
        this.creditLineContactErrors = [];
      }
      return (
        this.$refs.form.validate() &&
        hasRelationshipContact > 0 &&
        hasCreditLineContact > 0
      );
    },
    addNewContact(item, oldForm) {
      const index = this.listCreditLineContact.indexOf(oldForm);
      const sameItems = this.listCreditLineContact.find(
        x => x.nome == item.nome && x.email == item.email
      );
      // previne duplicidade de cadastro (nome e email iguals)
      // tanto para novos contatos ou edição
      if (
        (sameItems && index == -1) ||
        (sameItems &&
          index > -1 &&
          sameItems != this.listCreditLineContact[index])
      ) {
        this.showAlertNotification({
          message: `Novo contato deve ter nome e email diferente dos atuais`,
          type: "error"
        });
        return;
      }
      // verifica se ele já existe na lista ou não
      if (index == -1) {
        this.form.contatos_linha_credito.push(item);
      } else {
        this.form.contatos_linha_credito[index] = item;
      }
      this.updateListCreditLineContact();
      this.modalCredit = false;
    },
    editCreditLineContact(item) {
      this.creditLineContact = item;
      this.titleModal = "EDITAR CONTATO LINHA DE CRÉDITO";
      this.modalCredit = true;
    },
    editRelationshipContact(item) {
      this.$emit(
        "relationshipContact",
        this.payloadInsuranceCompany(this.form, this.contactsStep, item)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "form.cnpj"(value) {
      if (BRUtils.isValidCNPJ(value)) {
        this.fetchLegalPerson();
      }
    },
    currentLegalPerson(value) {
      if (value) {
        // Atualizar Caso o campo não esteja
        // preenchido
        this.form.endereco.cep = this.form.endereco.cep
          ? this.form.endereco.cep
          : value.endereco.cep;
        this.form.endereco.logradouro = this.form.endereco.logradouro
          ? this.form.endereco.logradouro
          : value.endereco.logradouro;
        this.form.endereco.numero = this.form.endereco.numero
          ? this.form.endereco.numero
          : value.endereco.numero;
        this.form.endereco.complemento = this.form.endereco.complemento
          ? this.form.endereco.complemento
          : value.endereco.complemento;
        this.form.endereco.bairro = this.form.endereco.bairro
          ? this.form.endereco.bairro
          : value.endereco.bairro;
        this.form.endereco.cidade = this.form.endereco.cidade
          ? this.form.endereco.cidade
          : value.endereco.cidade;
        this.form.endereco.uf = this.form.endereco.uf
          ? this.form.endereco.uf
          : value.endereco.uf;
        this.form.razao_social = value.razao_social
          ? value.razao_social
          : this.form.razao_social;
        this.form.nome_fantasia = value.nome_fantasia
          ? value.nome_fantasia
          : this.form.nome_fantasia;
      }
    }
  }
};
</script>
